import React, { useState, useContext } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
  required,
} from "../../../utils";
import {
  getPlanEligibilityReport,
  downloadPlanEligibilityReport,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
  downloadPayrollWorkloadAnticipationReport,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "../402ContributionLimit/columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { createPlanStore } from "../../../contexts";
const today = new Date();

const initialValues = {
  periodStartDate: new Date(today.setDate(today.getDate())),
  periodEndDate: new Date(today.setDate(today.getDate() + 30)),
};

function PayrollWorkload(props) {
  const formName = manageReportsFormNames.PAYROLL_WORKLOAD_ANTICIPATION_REPORT;
  const { state, dispatch } = useContext(createPlanStore);
  const fields = formFields[formName];
  const [planList, setPlanList] = useState([]);
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const exportReportFile = (data) => {
    downloadPayrollWorkloadAnticipationReport(data)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `Payroll workload report_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const onSubmit = (values) => {
    var filters = {
      periodStartDate: values[fields.periodStartDate],
      periodEndDate: values[fields.periodEndDate],
    };
    exportReportFile(filters);
  };

  return (
    <ManageReportLayout rptName="Payroll Workload Anticipation Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              values,
              setErrors,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex">
                    <div className="d-flex mr-4">
                      <div className="d-flex ml-4 mr-1">
                        <Field
                          size="sm"
                          label="Period start date "
                          isRequired
                          name={fields.periodStartDate}
                          value={usDateFormat(values[fields.periodStartDate])}
                          direction="bottom"
                          isDatePicker
                          validate={required}
                          onClear={() =>
                            setFieldValue(fields.periodStartDate, null)
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.periodStartDate, value)
                              }
                              value={usDateFormat(
                                values[fields.periodStartDate]
                              )}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Period end date "
                          isRequired
                          name={fields.periodEndDate}
                          value={usDateFormat(values[fields.periodEndDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.periodEndDate, null)
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.periodEndDate, value)
                              }
                              value={usDateFormat(values[fields.periodEndDate])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              "Required"
                            ) : value < values[fields.periodStartDate] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      className="mt-12 sort-button "
                      style={{ marginTop: "30px" }}
                      variant="secondary"
                      onClick={(e) => {
                        setFieldValue(
                          fields.periodEndDate,
                          initialValues.periodEndDate
                        );
                        setFieldValue(
                          fields.periodStartDate,
                          initialValues.periodStartDate
                        );
                        setErrors({});
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      className="mt-12 sort-button "
                      //  style={{ lineHeight: "19px", marginleft: "10%" }}
                      variant="secondary"
                      type="submit"
                      style={{ marginLeft: "8px", marginTop: "30px" }}
                    >
                      Request Report
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
}

export default PayrollWorkload;
